// extracted by mini-css-extract-plugin
export var closeButton = "_19-3";
export var header = "_19-0";
export var link = "_19-1";
export var retryButton = "_19-2";